import { render, staticRenderFns } from "./ShipmentShipped.vue?vue&type=template&id=75be98b6&"
import script from "./ShipmentShipped.vue?vue&type=script&lang=js&"
export * from "./ShipmentShipped.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentShipped.vue?vue&type=style&index=0&id=75be98b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports